import { http } from '@/core/api/';

const baseURL = 'api/me/request';
const baseRequisitionsURL = 'api/me/requisition';

export const getSearchResult = (filter) => {
  return http.get(`${baseURL}/search`, {
    params: {
      fiscalYear: filter.fiscalYear,
      statusId: filter.statusId,
      requestNumber: filter.requestNumber,
      classroomTypeId: filter.classroomType,
      locationSchoolId: filter.locationSchool,
      pageIndex: filter.pageIndex,
      pageSize: filter.pageSize,
    },
  });
};

export const getCatalogSearchResult = (params) => {
  return http.get(`${baseURL}/catalog`, { params });
};

export const getCatalogArticleSearchResult = (params) => {
  return http.get(`${baseURL}/catalogarticles`, { params });
};

export const hasNewRequestsBySaloon = (saloonId) => {
  return http.get(`${baseURL}/saloon/${saloonId}/hasnewrequests`);
};

export const deleteSaloon = (saloonId, categoryId) => {
  return http.delete(`${baseURL}/saloon/${saloonId}/category/${categoryId}`);
};

export const getTargetRequestStatuses = (statusId) => {
  return http.get(`${baseURL}/targetstatuses/${statusId}`);
};

export const submitRequest = (data) => {
  return http.post(`${baseURL}/save`, data);
};

export const uploadDocument = (data) => {
  return http.post(`${baseURL}/document`, data, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

export const getRequestDetail = (id) => {
  return http.get(`${baseURL}/detail/${id}`);
};

export const changeRequestStatus = (requestId, data) =>
  http.put(`${baseURL}/${requestId}/statuschange`, data);

export const getRequestDocuments = (id) =>
  http.get(`${baseURL}/alldocuments/${id}`);

export const deleteEvidenceDocument = (documentId) =>
  http.put(`${baseURL}/evidencedocument/${documentId}`);

export const getRequestedItems = (fiscalYearId) =>
  http.get(`${baseURL}/requesteditems/${fiscalYearId}`);

export const getRequestedItemsDetail = (fiscalYearId, materialItemTypeId) =>
  http.get(`${baseURL}/requesteditems/${fiscalYearId}/${materialItemTypeId}`);

export const getSearchRequisitionsResult = (filter) => {
  return http.get(`${baseRequisitionsURL}/search`, {
    params: {
      fiscalYearId: filter.fiscalYearId,
      statusId: filter.statusId,
      requisitionTypeId: filter.requisitionTypeId,
      searchCriteria: filter.searchCriteria,
      pageIndex: filter.pageIndex,
      pageSize: filter.pageSize,
    },
  });
};
export const saveRequisition = (data) =>
  http.post(`${baseRequisitionsURL}/add`, data);

export const getRequisitionDetail = (requistionId) =>
  http.get(`${baseRequisitionsURL}/detail/${requistionId}`);

export const getRequestedDetailArticles = (params) =>
  http.get(`${baseRequisitionsURL}/detail/articles`, { params });

export const submitRequisition = (requisitionId, params) =>
  http.post(`${baseRequisitionsURL}/submit/${requisitionId}`, params);

export const getRequestHistory = (id) =>
  http.get(`${baseURL}/requesthistory/${id}`);
